export default {
  'pages.layouts.userLayout.title': 'To create a global open ecosystem for mini-games',
  'pages.login.platformTitle': 'PlaysOut Developer Platform',
  'pages.login.gameEnginesTitle': 'Compatible game engines',
  'pages.login.partnersTitle': 'Partners',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password (admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Username is required!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Password is required!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'Retry after seconds',
  'pages.login.rememberMe': 'Auto Login',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Other Login Methods :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by admin',
  'pages.admin.subPage.alertMessage': 'umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule Configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules': 'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Rule Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Start Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'Closed',
  'pages.searchTable.nameStatus.running': 'Running',
  'pages.searchTable.nameStatus.online': 'Online',
  'pages.searchTable.nameStatus.abnormal': 'Abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled Time',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Operation',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to Alerts',
  'pages.searchTable.title': 'Query Table',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'Selected',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Service Calls',
  'pages.searchTable.tenThousand': '10K',
  'pages.searchTable.batchDeletion': 'Batch Deletion',
  'pages.searchTable.batchApproval': 'Batch Approval',

  // Game Management
  'pages.games.createModal.title': 'Add New Mini Game',
  'pages.games.createModal.gameName': 'Game Name',
  'pages.games.createModal.gameName.placeholder': 'Please enter game name',
  'pages.games.createModal.category': 'Game Category',
  'pages.games.createModal.category.required': 'Please select at least one category',
  'pages.games.createModal.category.max': 'Maximum 3 categories',
  'pages.games.createModal.description': 'Game Summary',
  'pages.games.createModal.description.placeholder': 'Please enter game summary',
  'pages.games.createModal.icon': 'Game Icon',
  'pages.games.createModal.icon.required': 'Please upload game icon',
  'pages.games.createModal.icon.tips': 'Only JPG/JPEG/PNG files, recommended resolution 512x512, max size 2MB',
  'pages.games.createModal.screenshots': 'Screenshots',
  'pages.games.createModal.screenshots.tips': 'Max 5 images (min 1080x1920px), JPG/JPEG/BMP/GIF/PNG, max 5MB each',
  'pages.games.createModal.detail': 'Game Description',
  'pages.games.createModal.detail.placeholder': 'Please enter detailed description',
  'pages.games.createModal.cancel': 'Cancel',
  'pages.games.createModal.submit': 'Submit',
  'pages.games.createModal.return.success': 'Game created successfully!',
  'pages.games.createModal.return.failure': 'Game creation failed, please try again!',

  // ... existing code ...

  // In-app purchase settings
  'pages.games.purchase.settings': 'In-App Purchase Settings',
  'pages.games.purchase.settingsTitle': 'In-App Purchase Configuration',
  'pages.games.purchase.comingSoon': 'Feature under development, stay tuned',
  'pages.games.purchase.enabled': 'Enabled',
  'pages.games.purchase.disabled': 'Disabled',
  'pages.games.purchase.placeholder': 'Enter callback URL',
  'pages.games.purchase.test': 'Test Configuration',
  'pages.games.purchase.submit': 'Save Configuration',
  'pages.games.purchase.emptyError': 'Configuration content cannot be empty',
  'pages.games.purchase.success': 'Configuration saved successfully',
  'pages.games.purchase.error': 'Failed to save configuration',
  'pages.games.purchase.urlPlaceholder': 'Enter valid purchase config URL (e.g. https://api.example.com/config)',
  'pages.games.purchase.invalidUrl': 'Please enter a valid URL',
  'pages.games.purchase.statusUpdateSuccess': 'Status updated successfully',
  'pages.games.purchase.statusUpdateError': 'Status update failed, please try again',

  // ... existing code ...

  // Validation Messages
  'pages.games.createModal.validation.iconFileType': 'Only JPG/PNG icons allowed!',
  'pages.games.createModal.validation.iconFileSize': 'Icon file size exceeds 2MB!',
  'pages.games.createModal.validation.createFailed': 'Game creation failed',

  // Category Options
  'pages.games.createModal.category.options.Action': 'Action',
  'pages.games.createModal.category.options.Adventure': 'Adventure',
  'pages.games.createModal.category.options.Arcade': 'Arcade',
  'pages.games.createModal.category.options.Card': 'Card',
  'pages.games.createModal.category.options.FPS': 'FPS',
  'pages.games.createModal.category.options..io': '.io',
  'pages.games.createModal.category.options.Puzzle': 'Puzzle',
  'pages.games.createModal.category.options.RPG': 'RPG',
  'pages.games.createModal.category.options.Sports': 'Sports',
  'pages.games.createModal.category.options.Tower Defense': 'Tower Defense',
  'pages.games.createModal.category.options.Simulator': 'Simulator',

  // Game Table
  'pages.games.table.columns.name': 'Game Name',
  'pages.games.table.columns.category': 'Category',
  'pages.games.table.columns.updateDate': 'Update Date',
  'pages.games.table.columns.createDate': 'Creation Date',
  'pages.games.table.columns.actions': 'Actions',
  'pages.games.table.actions.manage': 'Manage',

  // Filters
  'pages.games.filter.button': 'Filter',
  'pages.games.filter.status.all': 'All',
  'pages.games.filter.status.active': 'Active',
  'pages.games.filter.status.inactive': 'Inactive',

  // Categories
  'pages.games.category.casual': 'Casual',
  'pages.games.category.puzzle': 'Puzzle',
  'pages.games.category.action': 'Action',
  'pages.games.category.simulation': 'Simulation',

  // Modals
  'pages.games.modal.filter.title': 'Filter Conditions',
  'pages.games.log.close': 'Popup closed, list refreshed',
  'pages.games.log.refresh': 'Data refresh completed',

  // Search & Actions
  'pages.games.search.placeholder': 'Search game name',
  'pages.games.modal.cancel': 'Cancel',
  'pages.games.modal.confirm': 'Confirm',
  'pages.games.create.button': 'Add Game',

  // Game Details
  'pages.games.detail.title': 'Game Details',
  'pages.games.detail.basicInfo': 'Basic Information',
  'pages.games.detail.name': 'Name:',
  'pages.games.detail.appId': 'AppID:',
  'pages.games.detail.category': 'Category:',
  'pages.games.detail.summary': 'Summary:',
  'pages.games.detail.description': 'Description:',

  // Version Management
  'pages.games.version.management': 'Version Management',
  'pages.games.gray.publish': 'Gray Release',
  'pages.games.privacy.settings': 'Privacy Settings',
  'pages.games.upload.progress': 'Uploading {percent}%',
  'pages.games.upload.success': 'Upload Successful',
  'pages.games.upload.error': 'Upload Failed',
  'pages.games.publish.title': 'Confirm Gray Release?',
  'pages.games.publish.content': 'This will overwrite current online version',
  'pages.games.review.submit': 'Submit for Review',
  'pages.games.review.success': 'Review Submitted',
  'pages.games.review.error': 'Submission Failed',
  'pages.games.publish.success': 'Gray Release Successful',
  'pages.games.publish.error': 'Release Failed',
  'pages.games.version.online': 'Online Version',
  'pages.games.version.viewData': 'View Data',
  'pages.games.version.notOnline': 'Game not online yet',
  'pages.games.review.auditing': 'Under review, please wait',
  'pages.games.review.rejectReason': 'Reason:',
  'pages.games.review.rejected': 'Review Rejected',
  'pages.games.review.approved': 'Congratulations! Review Approved',
  'pages.games.version.grayVersion': 'Gray Version',
  'pages.games.version.currentGray': 'Current Gray Version: v{version}',
  'pages.games.version.devVersion': 'Dev Version',
  'pages.games.upload.submit': 'Submit New Dev Version',
  'pages.games.upload.tips': 'ZIP files only, max 30MB',
  'pages.games.version.uploadFirst': 'Upload dev version first',
  'pages.games.publish.button': 'Publish Now',
  'pages.games.review.title': 'Confirm Submission?',
  'pages.games.review.content': 'Review will complete in 1-3 working days',
  'pages.games.review.button': 'Submit Review',
  'pages.games.upload.uploading': 'Uploading...',
  'pages.games.upload.zipOnly': 'ZIP files only',
  'pages.games.upload.sizeLimit': 'File size exceeds 30MB',
  'pages.games.review.auditPrompt': 'Game is under review, please wait',
  'pages.games.upload.submitDevVersion': 'Submit New Dev Version',
  'pages.games.detail.detailedInfo': 'Detailed Info',

  // Icon modification translations
  'pages.games.detail.modifyIcon': 'Modify Icon',
  'pages.games.detail.saveIcon': 'Save Changes',
  'pages.games.detail.icon.required': 'Please select a new icon first',
  'pages.games.detail.icon.success': 'Icon updated successfully',
  'pages.games.detail.icon.error': 'Failed to update icon',

  // Game Management Specific
  'pages.gameManagement.table.columns.name': 'Game Name',
  'pages.gameManagement.table.columns.category': 'Game Type',
  'pages.gameManagement.table.columns.updateDate': 'Update Date',
  'pages.gameManagement.table.columns.createDate': 'Creation Date',
  'pages.gameManagement.table.columns.actions': 'Actions',

  'pages.gameManagement.modal.title': 'Game Detail Management',
  'pages.gameManagement.modal.basicInfo': 'Basic Information',
  'pages.gameManagement.modal.reviewComment': 'Review Comments',
  'pages.gameManagement.modal.actions.close': 'Close',
  'pages.gameManagement.modal.actions.reject': 'Reject',
  'pages.gameManagement.modal.actions.approve': 'Approve',

  'pages.gameManagement.review.comment.placeholder': 'Enter review comments',
  'pages.gameManagement.qrCode.text': 'Scan to Play',
  'pages.gameManagement.review.messages.noSelection': 'No game selected',
  'pages.gameManagement.review.messages.approveSuccess': 'Approval successful',
  'pages.gameManagement.review.messages.rejectSuccess': 'Rejection successful',
  'pages.gameManagement.review.messages.operationFailed': 'Operation failed: {msg}',
  'pages.gameManagement.review.messages.retryLater': 'Operation failed, please try again later',

  'pages.gameManagement.status.published': 'Published',
  'pages.gameManagement.status.underReview': 'Under Review',

  // New table columns (synced from Chinese version)
  'pages.gameManagement.table.columns.gameId': 'Game ID',
  'pages.gameManagement.table.columns.status': 'Status',
  'pages.gameManagement.offline.button': 'Take Down',
  'pages.gameManagement.offline.confirm': 'Confirm to take down this game?',

  // Existing login configuration
  'pages.login.googleSignIn': 'Sign in with Google',

  "pages.games.detail.help": "Help",
  "pages.games.detail.help.title": "Field Descriptions",
  "pages.games.detail.help.content": "AppID--> offerId \n Purchase Key--> AppKey",

  // Game deletion related
  "pages.games.delete.button": "Delete Game",
  "pages.games.delete.inputPlaceholder": "Please enter game name '{gameName}' to confirm deletion",
  "pages.games.delete.confirmButton": "Confirm Deletion",
  "pages.games.delete.cancelButton": "Cancel",
  "pages.games.delete.confirm.title": "Confirm Game Deletion",
  "pages.games.delete.confirm.content": "Deletion cannot be undone. Are you sure you want to delete this game?",
  "pages.games.delete.confirm.ok": "Confirm Deletion",
  "pages.games.delete.confirm.cancel": "Cancel",
  "pages.games.delete.success": "Game deleted successfully",
  "pages.games.delete.error": "Failed to delete game",

  // SDK User - Credentials
  "pages.sdkUser.credentials.defaultProjectName": "Game Platform SDK",
  "pages.sdkUser.credentials.noChannelInfo": "No channel information available. Please create a channel first.",
  "pages.sdkUser.credentials.copySuccess": "SDK Key copied to clipboard",
  "pages.sdkUser.credentials.copyFailed": "Copy failed, please copy manually",
  "pages.sdkUser.credentials.showCreateModal": "Show create modal",
  "pages.sdkUser.credentials.showUpdateModal": "Show update modal:",
  "pages.sdkUser.credentials.updateSuccess": "SDK Key updated successfully",
  "pages.sdkUser.credentials.generateSuccess": "SDK Key generated successfully",
  "pages.sdkUser.credentials.updateFailed": "Failed to update SDK Key",
  "pages.sdkUser.credentials.generateFailed": "Failed to generate SDK Key",
  "pages.sdkUser.credentials.requestFailed": "Request failed, please try again later",
  "pages.sdkUser.credentials.validationFailed": "Form validation failed:",
  "pages.sdkUser.credentials.table.platform": "Platform",
  "pages.sdkUser.credentials.table.packageName": "Package Name",
  "pages.sdkUser.credentials.table.sdkKey": "SDK Key",
  "pages.sdkUser.credentials.table.validityStart": "Validity Start",
  "pages.sdkUser.credentials.table.validityEnd": "Validity End",
  "pages.sdkUser.credentials.table.status": "Status",
  "pages.sdkUser.credentials.table.actions": "Actions",
  "pages.sdkUser.credentials.action.view": "View",
  "pages.sdkUser.credentials.action.hide": "Hide",
  "pages.sdkUser.credentials.action.update": "Update",
  "pages.sdkUser.credentials.stat.activeKeys": "Active Keys",
  "pages.sdkUser.credentials.stat.inactiveKeys": "Inactive Keys",
  "pages.sdkUser.credentials.empty": "No credential data available",
  "pages.sdkUser.credentials.modal.updateTitle": "Update SDK Key",
  "pages.sdkUser.credentials.modal.generateTitle": "Generate New SDK Key",
  "pages.sdkUser.credentials.modal.updateButton": "Update",
  "pages.sdkUser.credentials.modal.generateButton": "Generate",
  "pages.sdkUser.credentials.modal.cancelButton": "Cancel",
  "pages.sdkUser.credentials.form.platform": "Platform",
  "pages.sdkUser.credentials.form.platformRequired": "Please select a platform",
  "pages.sdkUser.credentials.form.platformPlaceholder": "Select platform",
  "pages.sdkUser.credentials.form.android": "Android",
  "pages.sdkUser.credentials.form.ios": "iOS",
  "pages.sdkUser.credentials.form.packageName": "Package Name",
  "pages.sdkUser.credentials.form.packageNameRequired": "Please enter package name",
  "pages.sdkUser.credentials.form.packageNamePlaceholder": "Enter package name (e.g. com.example.game)",
  "pages.sdkUser.credentials.form.validDays": "Valid Days",
  "pages.sdkUser.credentials.form.validDaysRequired": "Please select validity days",
  "pages.sdkUser.credentials.form.validDaysMin": "Validity days must be between 1 and 9999",
  "pages.sdkUser.credentials.form.validDaysPlaceholder": "Select valid days",
  "pages.sdkUser.credentials.form.day30": "1 Month (30 days)",
  "pages.sdkUser.credentials.form.day365": "1 Year (365 days)",
  "pages.sdkUser.credentials.form.day730": "2 Years (730 days)",
  "pages.sdkUser.credentials.form.day3650": "10 Years (3650 days)",
  "pages.sdkUser.credentials.form.day36500": "100 Years (36500 days)",
  "pages.sdkUser.credentials.title": "{projectName} Credentials",
  "pages.sdkUser.credentials.description": "Manage Channel IDs and SDK Keys for this project.",
  "pages.sdkUser.credentials.generateButton": "+ Generate New Key",

  // SDK User - Projects
  "pages.sdkUser.projects.loadCacheFailed": "Failed to load cache data:",
  "pages.sdkUser.projects.fetchFailed": "Failed to fetch channel list",
  "pages.sdkUser.projects.userNotLoggedIn": "User not logged in or email information not obtained",
  "pages.sdkUser.projects.createSuccess": "Project created successfully",
  "pages.sdkUser.projects.createFailed": "Project creation failed",
  "pages.sdkUser.projects.createRetry": "Project creation failed, please try again later",
  "pages.sdkUser.projects.deleteConfirmTitle": "Confirm Deletion",
  "pages.sdkUser.projects.deleteConfirmContent": "Are you sure you want to delete project \"{name}\"? This action cannot be undone.",
  "pages.sdkUser.projects.deleteConfirmButton": "Confirm Deletion",
  "pages.sdkUser.projects.deleteCancelButton": "Cancel",
  "pages.sdkUser.projects.deleteSuccess": "Project deleted successfully",
  "pages.sdkUser.projects.deleteFailed": "Project deletion failed",
  "pages.sdkUser.projects.deleteRetry": "Project deletion failed, please try again later",
  "pages.sdkUser.projects.movedToFirst": "Project moved to first position in cache:",
  "pages.sdkUser.projects.table.name": "Project Name",
  "pages.sdkUser.projects.table.status": "Status",
  "pages.sdkUser.projects.table.statusActive": "Active",
  "pages.sdkUser.projects.table.statusInactive": "Inactive",
  "pages.sdkUser.projects.table.type": "Type",
  "pages.sdkUser.projects.table.typeMobile": "Mobile Game",
  "pages.sdkUser.projects.table.typePC": "PC Game",
  "pages.sdkUser.projects.table.createdAt": "Created At",
  "pages.sdkUser.projects.table.updatedAt": "Updated At",
  "pages.sdkUser.projects.table.actions": "Actions",
  "pages.sdkUser.projects.action.manage": "Manage",
  "pages.sdkUser.projects.action.delete": "Delete",
  "pages.sdkUser.projects.title": "Project List",
  "pages.sdkUser.projects.createButton": "Create Project",
  "pages.sdkUser.projects.empty": "You haven't created any projects yet",
  "pages.sdkUser.projects.createFirstButton": "Create First Project",
  "pages.sdkUser.projects.modal.title": "Create Project",
  "pages.sdkUser.projects.form.name": "Project Name",
  "pages.sdkUser.projects.form.namePlaceholder": "Please enter project name",
  "pages.sdkUser.projects.form.nameRequired": "Please enter project name",
  "pages.sdkUser.projects.form.nameLength": "Project name must be between 3 and 50 characters",
  "pages.sdkUser.projects.form.namePattern": "Project name can only contain letters, numbers and underscores. Spaces and special characters are not allowed",
  "pages.sdkUser.projects.form.nameMustContainLetter": "Project name must contain at least one letter",
  "pages.sdkUser.projects.form.type": "Project Type",
  "pages.sdkUser.projects.form.typePlaceholder": "Please select project type",
  "pages.sdkUser.projects.form.typeRequired": "Please select project type",
  "pages.sdkUser.projects.form.description": "Project Description",
  "pages.sdkUser.projects.form.descriptionPlaceholder": "Please enter project description",
  "pages.sdkUser.projects.form.submitButton": "Create Project",
  "pages.sdkUser.projects.form.noDescription": "No description",

  // SDK User - ProjectDetail
  "pages.sdkUser.projectDetail.title": "Project: {name}",
  "pages.sdkUser.projectDetail.loadCacheFailed": "Failed to load cache data:",
  "pages.sdkUser.projectDetail.loadFailed": "Failed to fetch project data:",
  "pages.sdkUser.projectDetail.loadStatsFailed": "Failed to fetch channel statistics:",
  "pages.sdkUser.projectDetail.table.date": "Date",
  "pages.sdkUser.projectDetail.table.users": "Users",
  "pages.sdkUser.projectDetail.table.revenue": "Revenue",
  "pages.sdkUser.projectDetail.table.dau": "DAU",
  "pages.sdkUser.projectDetail.typeMobile": "Mobile Game",
  "pages.sdkUser.projectDetail.typePC": "PC Game",
  "pages.sdkUser.projectDetail.noDescription": "No description",
  "pages.sdkUser.projectDetail.defaultDescription": "Analytics overview for your Mobile Game workspace.",
  "pages.sdkUser.projectDetail.notFound": "Project information not found",
  "pages.sdkUser.projectDetail.cardTitle": "Project Details",
  "pages.sdkUser.projectDetail.integration.title": "Integrate {name}",
  "pages.sdkUser.projectDetail.integration.description": "Get the keys specific to this project to start tracking users and sessions immediately.",
  "pages.sdkUser.projectDetail.integration.manageButton": "Manage SDK Keys",
  "pages.sdkUser.projectDetail.integration.docsButton": "Documentation",
  "pages.sdkUser.projectDetail.manageGamesButton": "Game Management",
  "pages.sdkUser.projectDetail.stats.liveStats": "Live Stats",
  "pages.sdkUser.projectDetail.stats.totalUsers": "Total Users",
  "pages.sdkUser.projectDetail.stats.dau": "DAU",
  "pages.sdkUser.projectDetail.stats.revenue": "Revenue",
  "pages.sdkUser.projectDetail.stats.usersTrend": "Users Trend",
  "pages.sdkUser.projectDetail.stats.growthTracking": "Growth tracking for the last 7 days",
  "pages.sdkUser.projectDetail.stats.dauRevenueTrends": "DAU & Revenue Trends",
  "pages.sdkUser.projectDetail.guides.title": "Integration Guides",
  "pages.sdkUser.projectDetail.guides.android.title": "Android SDK",
  "pages.sdkUser.projectDetail.guides.android.docsButton": "View Documentation",
  "pages.sdkUser.projectDetail.guides.android.name": "PlaysOut SDK demo for Android",
  "pages.sdkUser.projectDetail.guides.android.description": "Full source code and implementation guide for native Android game integration.",
  "pages.sdkUser.projectDetail.guides.ios.title": "iOS SDK",
  "pages.sdkUser.projectDetail.guides.ios.docsButton": "View Documentation",
  "pages.sdkUser.projectDetail.guides.ios.name": "PlaysOut SDK demo for IOS",
  "pages.sdkUser.projectDetail.guides.ios.description": "Swift-ready demo project to accelerate your iOS deployment and session tracking.",
  "pages.sdkUser.projectDetail.guides.other.title": "Other Guides",
  "pages.sdkUser.projectDetail.guides.other.docsButton": "View Documentation",
  "pages.sdkUser.projectDetail.guides.other.name": "Other Guides",
  "pages.sdkUser.projectDetail.guides.other.description": "Explore documentation for WebGL, Unity, and cross-platform custom engine wrappers.",

  // SDK User - Game Selection
  "pages.sdkUser.gameSelection.title": "Game Selection Management",
  "pages.sdkUser.gameSelection.selectedGames": "My Selected Games",
  "pages.sdkUser.gameSelection.availableGames": "Game Library",
  "pages.sdkUser.gameSelection.searchPlaceholder": "Search game name",
  "pages.sdkUser.gameSelection.allCategories": "All Categories",
  "pages.sdkUser.gameSelection.add": "Add",
  "pages.sdkUser.gameSelection.remove": "Remove",
  "pages.sdkUser.gameSelection.saveButton": "Save Selection ({count})",
  "pages.sdkUser.gameSelection.clearButton": "Clear All",
  "pages.sdkUser.gameSelection.refreshButton": "Refresh",
  "pages.sdkUser.gameSelection.dragHint": "Drag to reorder",
  "pages.sdkUser.gameSelection.updatedAt": "Updated {date}",
  "pages.sdkUser.gameSelection.empty.selected": "No selected games",
  "pages.sdkUser.gameSelection.empty.available": "No available games",
  "pages.sdkUser.gameSelection.saveSuccess": "Saved successfully",
  "pages.sdkUser.gameSelection.clearSuccess": "All selected games cleared",
  "pages.sdkUser.gameSelection.clearConfirm.title": "Confirm Clear",
  "pages.sdkUser.gameSelection.clearConfirm.content": "Are you sure you want to clear all selected games? This action cannot be undone.",
  "pages.sdkUser.gameSelection.clearConfirm.ok": "Confirm",
  "pages.sdkUser.gameSelection.clearConfirm.cancel": "Cancel",
  "pages.sdkUser.gameSelection.error.noUser": "Unable to get user information",
  "pages.sdkUser.gameSelection.error.loadFailed": "Failed to load game list",
  "pages.sdkUser.gameSelection.error.saveFailed": "Save failed, please try again later",
  "pages.sdkUser.gameSelection.warning.noSelection": "Please select at least one game",

  // SDK User - Project Detail New
  "pages.sdkUser.projectDetailNew.tab.detail": "Game Details",
  "pages.sdkUser.projectDetailNew.tab.games": "Game Management",
  "pages.sdkUser.projectDetailNew.tab.selection": "Game Selection List",
  "pages.sdkUser.projectDetailNew.warning.noProject": "Unable to get project information",
  "pages.sdkUser.projectDetailNew.games.empty.description": "Manage mini-games for this channel, including creating, editing, and publishing games",
  "pages.sdkUser.projectDetailNew.games.manageButton": "Go to Game Management",
  "pages.sdkUser.projectDetail.error.loadFailed": "Failed to load project data",

  // Home Page - Admin Dashboard
  "pages.home.admin.title": "Admin Console",
  "pages.home.admin.welcome": "Welcome back, {name}! System is running normally",
  "pages.home.admin.stat.totalUsers": "Total Users",
  "pages.home.admin.stat.totalGames": "Total Games",
  "pages.home.admin.stat.pendingReview": "Pending Review",
  "pages.home.admin.stat.todayVisits": "Today's Visits",
  "pages.home.admin.section.management": "Management",
  "pages.home.admin.card.userManagement": "User Management",
  "pages.home.admin.card.userManagement.desc": "Invite and manage system users",
  "pages.home.admin.card.gameAnalytics": "Game Analytics",
  "pages.home.admin.card.gameAnalytics.desc": "View game data analysis",
  "pages.home.admin.card.cdnManagement": "CDN Management",
  "pages.home.admin.card.cdnManagement.desc": "Configure and manage CDN resources",
  "pages.home.admin.card.channelManagement": "Channel Management",
  "pages.home.admin.card.channelManagement.desc": "Manage player channel configuration",
  "pages.home.admin.section.announcements": "Announcements",
  "pages.home.admin.announcement.latest": "Latest",
  "pages.home.admin.announcement.normal": "System Normal",
  "pages.home.admin.announcement.normal.desc": "All services are running normally",
  "pages.home.admin.announcement.update": "Update",
  "pages.home.admin.announcement.update.title": "Feature Optimization",
  "pages.home.admin.announcement.update.desc": "Admin panel features are being optimized",

  // Home Page - User Dashboard
  "pages.home.user.welcome": "Welcome back, {name}!",
  "pages.home.user.subtitle": "Start creating and managing your game projects",
  "pages.home.user.stat.myGames": "My Games",
  "pages.home.user.stat.totalUsers": "Total Users",
  "pages.home.user.stat.todayActive": "Today Active",
  "pages.home.user.stat.totalRevenue": "Total Revenue",
  "pages.home.user.section.quickActions": "Quick Actions",
  "pages.home.user.card.gameManagement": "Game Management",
  "pages.home.user.card.gameManagement.desc": "Create and manage game projects",
  "pages.home.user.card.statistics": "Statistics",
  "pages.home.user.card.statistics.desc": "View game data and user analytics",
  "pages.home.user.card.playerAnalytics": "Player Analytics",
  "pages.home.user.card.playerAnalytics.desc": "Deep dive into player behavior",
  "pages.home.user.card.createGame": "Create Game",
  "pages.home.user.card.createGame.desc": "Quickly create new game projects",
  "pages.home.user.section.features": "Platform Features",
  "pages.home.user.feature.secure": "Secure",
  "pages.home.user.feature.secure.desc": "Enterprise-level security",
  "pages.home.user.feature.flexible": "Flexible Integration",
  "pages.home.user.feature.flexible.desc": "Comprehensive SDK support",
  "pages.home.user.feature.performance": "High Performance",
  "pages.home.user.feature.performance.desc": "Global node deployment",
  "pages.home.user.feature.global": "Global",
  "pages.home.user.feature.global.desc": "Serving users worldwide",

  // Home Page - Reviewer Dashboard
  "pages.home.reviewer.title": "Reviewer Console",
  "pages.home.reviewer.welcome": "Welcome back, {name}! Pending tasks: 0",
  "pages.home.reviewer.stat.pending": "Pending",
  "pages.home.reviewer.stat.approved": "Approved",
  "pages.home.reviewer.stat.rejected": "Rejected",
  "pages.home.reviewer.stat.todayReviews": "Today's Reviews",
  "pages.home.reviewer.section.tasks": "Review Tasks",
  "pages.home.reviewer.card.pending": "Pending",
  "pages.home.reviewer.card.pending.desc": "View pending games",
  "pages.home.reviewer.card.history": "Review History",
  "pages.home.reviewer.card.history.desc": "View review records",
  "pages.home.reviewer.card.gameList": "Game List",
  "pages.home.reviewer.card.gameList.desc": "View all games",
  "pages.home.reviewer.card.dataAnalysis": "Data Analysis",
  "pages.home.reviewer.card.dataAnalysis.desc": "View game data",
  "pages.home.reviewer.section.guide": "Review Guide",
  "pages.home.reviewer.guide.tip": "Tips",
  "pages.home.reviewer.guide.standard": "Review Standards",
  "pages.home.reviewer.guide.standard.desc": "Carefully check game content, icons, descriptions, etc.",
  "pages.home.reviewer.guide.norm": "Guidelines",
  "pages.home.reviewer.guide.process": "Review Process",
  "pages.home.reviewer.guide.process.desc": "View game details, check content, make review decision",

  // Home Page - SDK User Dashboard
  "pages.home.sdkUser.title": "SDK User Center",
  "pages.home.sdkUser.welcome": "Welcome back, {name}!",
  "pages.home.sdkUser.stat.myProjects": "My Projects",
  "pages.home.sdkUser.stat.sdkCredentials": "SDK Credentials",
  "pages.home.sdkUser.stat.activeProjects": "Active Projects",
  "pages.home.sdkUser.stat.totalCalls": "Total Calls",
  "pages.home.sdkUser.section.projectManagement": "Project Management",
  "pages.home.sdkUser.card.projectList": "Project List",
  "pages.home.sdkUser.card.projectList.desc": "Manage your SDK projects",
  "pages.home.sdkUser.card.credentials": "SDK Credentials",
  "pages.home.sdkUser.card.credentials.desc": "Manage SDK keys and credentials",
  "pages.home.sdkUser.card.createProject": "Create Project",
  "pages.home.sdkUser.card.createProject.desc": "Create new SDK project",
  "pages.home.sdkUser.card.apiDocs": "API Documentation",
  "pages.home.sdkUser.card.apiDocs.desc": "View API usage documentation",
  "pages.home.sdkUser.section.features": "SDK Features",
  "pages.home.sdkUser.feature.secure": "Secure Authentication",
  "pages.home.sdkUser.feature.secure.desc": "Multi-layer security",
  "pages.home.sdkUser.feature.performance": "High Performance",
  "pages.home.sdkUser.feature.performance.desc": "Low latency, high concurrency",
  "pages.home.sdkUser.feature.integration": "Easy Integration",
  "pages.home.sdkUser.feature.integration.desc": "Comprehensive SDK documentation",
  "pages.home.sdkUser.feature.global": "Global Service",
  "pages.home.sdkUser.feature.global.desc": "Global node coverage",

  // SDK User - Game Management
  "pages.sdkUser.gameManagement.title": "Game Management",
  "pages.sdkUser.gameManagement.description": "Manage games here",
  "pages.sdkUser.gameManagement.gameDetail": "Game Details",
  "pages.sdkUser.gameManagement.recommendation": "Recommendation Management",
  "pages.sdkUser.gameManagement.refresh": "Refresh",
  "pages.sdkUser.gameManagement.filter": "Filter",
  "pages.sdkUser.gameManagement.create": "Add Game",
  "pages.sdkUser.gameManagement.table.name": "Game Name",
  "pages.sdkUser.gameManagement.table.category": "Game Category",
  "pages.sdkUser.gameManagement.table.status": "Status",
  "pages.sdkUser.gameManagement.table.updateDate": "Update Date",
  "pages.sdkUser.gameManagement.table.createDate": "Create Date",
  "pages.sdkUser.gameManagement.table.actions": "Actions",
  "pages.sdkUser.gameManagement.action.manage": "Manage",
  "pages.sdkUser.gameManagement.category.casual": "Casual",
  "pages.sdkUser.gameManagement.category.puzzle": "Puzzle",
  "pages.sdkUser.gameManagement.category.action": "Action",
  "pages.sdkUser.gameManagement.category.simulation": "Simulation",
  "pages.sdkUser.gameManagement.status.active": "Published",
  "pages.sdkUser.gameManagement.status.inactive": "Pending",
  "pages.sdkUser.gameManagement.filter.status.all": "All",
  "pages.sdkUser.gameManagement.filter.status.active": "Published",
  "pages.sdkUser.gameManagement.filter.status.inactive": "Pending",
  "pages.sdkUser.gameManagement.filter.title": "Filter Criteria",
  "pages.sdkUser.gameManagement.createModal.title": "Add Game",
  "pages.sdkUser.gameManagement.createModal.comingSoon": "This feature is coming soon, please stay tuned!",
  "pages.sdkUser.gameManagement.detailModal.title": "Game Details",
  "pages.sdkUser.gameManagement.detail.category": "Category",
  "pages.sdkUser.gameManagement.detail.status": "Status",
  "pages.sdkUser.gameManagement.detail.description": "Description",
  "pages.sdkUser.gameManagement.detail.created": "Created At",
  "pages.sdkUser.gameManagement.detail.updated": "Updated At",
  "pages.sdkUser.gameManagement.detail.noDescription": "No description",
  "pages.sdkUser.gameManagement.modal.confirm": "Confirm",
  "pages.sdkUser.gameManagement.modal.cancel": "Cancel",
  "pages.sdkUser.gameManagement.empty": "No games available",
  "pages.sdkUser.gameManagement.error.loadFailed": "Failed to load game list",
  "pages.sdkUser.gameManagement.error.noChannel": "Channel information not found",
  "pages.sdkUser.gameManagement.tabs.detail": "Game Details",
  "pages.sdkUser.gameManagement.tabs.management": "Game Management",
  "pages.sdkUser.gameManagement.tabs.recommendation": "Recommendation Management",
  "pages.sdkUser.gameManagement.detailTab.empty": "Game details feature is under development, please stay tuned!",
  "pages.sdkUser.gameManagement.recommendationTab.empty": "Recommendation management feature is under development, please stay tuned!",
  "pages.sdkUser.gameManagement.search.placeholder": "Search games...",
  "pages.sdkUser.gameManagement.action.publish": "Publish",
  "pages.sdkUser.gameManagement.action.unpublish": "Unpublish",
  "pages.sdkUser.gameManagement.table.activeUsers": "Active Users",
  "pages.sdkUser.gameManagement.table.retention1Day": "1-Day Retention",
  "pages.sdkUser.gameManagement.table.retention7Day": "7-Day Retention",
  "pages.sdkUser.gameManagement.table.adImpressions": "Ad Impressions",
  "pages.sdkUser.gameManagement.table.adRevenue": "Ad Revenue",
  "pages.sdkUser.gameManagement.detail.stats.totalGames": "Total Games",
  "pages.sdkUser.gameManagement.detail.stats.gamePlayers": "Game Players",
  "pages.sdkUser.gameManagement.detail.stats.avgPlayTime": "Total Launches",
  "pages.sdkUser.gameManagement.detail.stats.gameRevenue": "Game Revenue",
  "pages.sdkUser.gameManagement.detail.ranking.title": "Top Games by Revenue",
  "pages.sdkUser.gameManagement.detail.ranking.viewDetails": "View Details",
  "pages.sdkUser.gameManagement.detail.table.activeUsers": "Active Users",
  "pages.sdkUser.gameManagement.detail.table.retention1Day": "1-Day Retention",
  "pages.sdkUser.gameManagement.detail.table.retention7Day": "7-Day Retention",
  "pages.sdkUser.gameManagement.detail.table.adImpressions": "Ad Impressions",
  "pages.sdkUser.gameManagement.detail.table.adRevenue": "Total Ad Revenue",
  "pages.sdkUser.gameManagement.recommendation.saveButton": "Save Recommendations ({count})",
  "pages.sdkUser.gameManagement.recommendation.clearButton": "Clear All",
  "pages.sdkUser.gameManagement.recommendation.refreshButton": "Refresh List",
  "pages.sdkUser.gameManagement.recommendation.selectedGames": "Recommended Games",
  "pages.sdkUser.gameManagement.recommendation.availableGames": "Available Games",
  "pages.sdkUser.gameManagement.recommendation.dragHint": "Drag to reorder recommendations",
  "pages.sdkUser.gameManagement.recommendation.add": "Add",
  "pages.sdkUser.gameManagement.recommendation.remove": "Remove",
  "pages.sdkUser.gameManagement.recommendation.updatedAt": "Updated {date}",
  "pages.sdkUser.gameManagement.recommendation.searchPlaceholder": "Search games",
  "pages.sdkUser.gameManagement.recommendation.categoryPlaceholder": "Select categories",
  "pages.sdkUser.gameManagement.recommendation.empty.selected": "No recommended games",
  "pages.sdkUser.gameManagement.recommendation.empty.available": "No available games",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.title": "Confirm Clear",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.content": "Are you sure you want to clear all recommended games?",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.ok": "Confirm",
  "pages.sdkUser.gameManagement.recommendation.clearConfirm.cancel": "Cancel",
  "pages.sdkUser.gameManagement.recommendation.saveSuccess": "Recommendations saved successfully",
  "pages.sdkUser.gameManagement.recommendation.clearSuccess": "Recommendations cleared successfully",
  "pages.sdkUser.gameManagement.recommendation.error.noOperator": "No operator information available",
  "pages.sdkUser.gameManagement.recommendation.warning.noSelection": "Please select at least one game",
  "pages.sdkUser.gameManagement.recommendation.error.saveFailed": "Failed to save recommendations",
  "pages.sdkUser.gameManagement.recommendation.error.clearFailed": "Failed to clear recommendations",

  "pages.sdkUser.gameManagement.tabs.customList": "Custom List",
  "pages.sdkUser.gameManagement.customList.name.label": "List Name",
  "pages.sdkUser.gameManagement.customList.name.placeholder": "Enter a list name, e.g. Puzzle Masters",
  "pages.sdkUser.gameManagement.customList.name.required": "Please enter a list name",
  "pages.sdkUser.gameManagement.customList.name.invalid": "Only letters, numbers and spaces are allowed; no leading/trailing or consecutive spaces",
  "pages.sdkUser.gameManagement.customList.name.tooLong": "List name cannot exceed 50 characters",
  "pages.sdkUser.gameManagement.customList.name.hint": "This name is visible to players; letters, numbers and spaces only",
  "pages.sdkUser.gameManagement.customList.mockNotice": "Demo mode: custom list data is stored locally in your browser until the backend API is ready",
  "pages.sdkUser.gameManagement.customList.saveButton": "Save List ({count})",
  "pages.sdkUser.gameManagement.customList.clearButton": "Clear List",
  "pages.sdkUser.gameManagement.customList.refreshButton": "Refresh List",
  "pages.sdkUser.gameManagement.customList.selectedGames": "Selected Games",
  "pages.sdkUser.gameManagement.customList.availableGames": "Available Games",
  "pages.sdkUser.gameManagement.customList.dragHint": "Drag to reorder",
  "pages.sdkUser.gameManagement.customList.add": "Add",
  "pages.sdkUser.gameManagement.customList.remove": "Remove",
  "pages.sdkUser.gameManagement.customList.updatedAt": "Updated {date}",
  "pages.sdkUser.gameManagement.customList.searchPlaceholder": "Search games",
  "pages.sdkUser.gameManagement.customList.empty.selected": "No selected games",
  "pages.sdkUser.gameManagement.customList.empty.available": "No available games",
  "pages.sdkUser.gameManagement.customList.clearConfirm.title": "Confirm Clear",
  "pages.sdkUser.gameManagement.customList.clearConfirm.content": "Are you sure you want to clear all games in this list?",
  "pages.sdkUser.gameManagement.customList.clearConfirm.ok": "Confirm",
  "pages.sdkUser.gameManagement.customList.clearConfirm.cancel": "Cancel",
  "pages.sdkUser.gameManagement.customList.clearSuccess": "Cleared successfully",
  "pages.sdkUser.gameManagement.customList.warning.noName": "Please enter a valid list name first",
  "pages.sdkUser.gameManagement.customList.saveSuccess": "List saved successfully",
  "pages.sdkUser.gameManagement.customList.error.saveFailed": "Failed to save list",
  "pages.sdkUser.gameManagement.customList.error.loadFailed": "Failed to load custom list",
  "pages.sdkUser.gameManagement.customList.error.noOperator": "No operator information available",

  // SDK User - API Documentation
  "pages.sdkUser.apiDocs.title": "API Documentation",
  "pages.sdkUser.apiDocs.description": "Explore our comprehensive API documentation and guides",
  "pages.sdkUser.apiDocs.category.gettingStarted": "Getting Started",
  "pages.sdkUser.apiDocs.category.api": "API Reference",
  "pages.sdkUser.apiDocs.category.guides": "Guides",
  "pages.sdkUser.apiDocs.category.platforms": "Platform Guides",
  "pages.sdkUser.apiDocs.tag.beginner": "Beginner",
  "pages.sdkUser.apiDocs.tag.integration": "Integration",
  "pages.sdkUser.apiDocs.tag.setup": "Setup",
  "pages.sdkUser.apiDocs.tag.installation": "Installation",
  "pages.sdkUser.apiDocs.tag.configuration": "Configuration",
  "pages.sdkUser.apiDocs.tag.platform": "Platform",
  "pages.sdkUser.apiDocs.tag.api": "API",
  "pages.sdkUser.apiDocs.tag.reference": "Reference",
  "pages.sdkUser.apiDocs.tag.methods": "Methods",
  "pages.sdkUser.apiDocs.tag.auth": "Authentication",
  "pages.sdkUser.apiDocs.tag.security": "Security",
  "pages.sdkUser.apiDocs.tag.session": "Session",
  "pages.sdkUser.apiDocs.tag.error": "Error",
  "pages.sdkUser.apiDocs.tag.debug": "Debug",
  "pages.sdkUser.apiDocs.tag.troubleshooting": "Troubleshooting",
  "pages.sdkUser.apiDocs.tag.performance": "Performance",
  "pages.sdkUser.apiDocs.tag.optimization": "Optimization",
  "pages.sdkUser.apiDocs.tag.best-practice": "Best Practice",
  "pages.sdkUser.apiDocs.tag.unity": "Unity",
  "pages.sdkUser.apiDocs.tag.cocos": "Cocos",
  "pages.sdkUser.apiDocs.tag.game-engine": "Game Engine",
  "pages.sdkUser.apiDocs.tag.games": "Games",
  "pages.sdkUser.apiDocs.tag.featured": "Featured",
  "pages.sdkUser.apiDocs.tag.list": "List",
  "pages.sdkUser.apiDocs.tag.ios": "iOS",
  "pages.sdkUser.apiDocs.tag.sdk": "SDK",
  "pages.sdkUser.apiDocs.tag.native": "Native",
  "pages.sdkUser.apiDocs.tag.android": "Android",
  "pages.sdkUser.apiDocs.category.guide": "Guide",
  "pages.sdkUser.apiDocs.viewDetail": "View Detail",
  "pages.sdkUser.apiDocs.empty": "No documentation available",
  "pages.sdkUser.apiDocs.back": "Back to List",
  "pages.sdkUser.apiDocs.content": "Document Content",
  "pages.sdkUser.apiDocs.invalidId": "Invalid document ID",
  "pages.sdkUser.apiDocs.notFound": "Document not found",
  "pages.sdkUser.apiDocs.loadFailed": "Failed to load document",

  // Common
  "pages.home.default.admin": "Admin",
  "pages.home.default.developer": "Developer",
  "pages.home.default.reviewer": "Reviewer",
  "pages.home.default.sdkUser": "SDK User",
  "pages.home.times": "times",
};